module.exports = __webpack_public_path__ + "static/img/9-ruijie.4d6d10e2.png";